import "./NewsFeed.css"

import { Web3WalletContainer } from "module/wallet/container/Web3WalletContainer"

import { Box, Button, Image, Link, VStack, useBreakpointValue } from "@chakra-ui/react"
import { Card } from "component/Card"
import { STAGE } from "constant/envVariables"
import { FeatureToggleContainer } from "container/service/FeatureToggleContainer"
import { useEffect, useState } from "react"
import ReactMarkdown from "react-markdown"
import Masonry from "react-masonry-css"
import { CMSQueryOverviewNews } from "service/airtable"

import { CollateralCap } from "./CollateralCap"
import { GaslessDeposit } from "./GaslessDeposit"

export function NewsFeed(props: { colOverride?: number }) {
    const { isBiconomyWidgetEnable } = FeatureToggleContainer.useContainer()

    const [news, setNews] = useState<any[]>([])
    useEffect(() => {
        CMSQueryOverviewNews.eachPage(
            function page(records, fetchNextPage) {
                const array = Object.values(records)
                setNews(array as any)
            },
            function done(err) {
                if (err) {
                    console.error(err)
                }
            },
        )
    }, [])

    const masonryCol = useBreakpointValue({ base: 1, lg: props.colOverride || 2 })
    const { account } = Web3WalletContainer.useContainer()
    const isConnected = !!account
    return (
        <Masonry breakpointCols={masonryCol} className="my-masonry-grid" columnClassName="my-masonry-grid_column">
            {isConnected && <CollateralCap />}

            {news.map((item, index) => {
                const itemEnv = item.fields["Staging"] ? "staging" : "production"
                const cover = item.fields["Cover"]
                const content = item.fields["Content (Markdown)"]
                const button = item.fields["Button"]
                const embeddedYoutube = item.fields["Youtube Embed"]
                const buttonLink = item.fields["Button Link"]
                const mp4Animation = item.fields["MP4 Animation"]
                const mp4AnimationLink = item.fields["MP4 Animation Link"]
                return (
                    <Card
                        key={index}
                        // show staging only card in staging environment
                        display={STAGE === "production" && itemEnv === "staging" ? "none" : undefined}
                        p={0}
                    >
                        {mp4Animation && (
                            <Link bg="red" href={mp4AnimationLink}>
                                <Box
                                    p={"1px"}
                                    autoPlay
                                    as="video"
                                    controls={false}
                                    loop={true}
                                    src={mp4Animation[0].url}
                                    objectFit="cover"
                                    sx={{
                                        aspectRatio: "2/1",
                                    }}
                                />
                            </Link>
                        )}
                        {cover && (
                            <Box as={"a"} href={item.fields["Cover Link"]} target="_blank">
                                <Image src={cover[0].thumbnails.large.url} />
                            </Box>
                        )}
                        <Box
                            as="iframe"
                            src={embeddedYoutube}
                            width={embeddedYoutube ? "100%" : 0}
                            allowFullScreen
                            sx={{
                                aspectRatio: "16/9",
                            }}
                        />
                        {content && (
                            <VStack align="stretch" spacing={6} p={{ base: 6, lg: 8 }} pb={{ base: 5, lg: 7 }}>
                                <Box>
                                    <ReactMarkdown
                                        className="markdown"
                                        components={{
                                            // Use h2s instead of h1s
                                            a: props => {
                                                return (
                                                    <a href={props.href} target="_blank" rel="noreferrer">
                                                        {props.children}
                                                    </a>
                                                ) // All links
                                            },
                                        }}
                                        children={content}
                                    />
                                </Box>

                                {button && (
                                    <Box>
                                        <Button
                                            as={Link}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                            href={buttonLink}
                                            _hover={{ textDecoration: "none" }}
                                            colorScheme="perpetual"
                                            variant="solid"
                                        >
                                            {button}
                                        </Button>
                                    </Box>
                                )}
                            </VStack>
                        )}
                    </Card>
                )
            })}

            {isBiconomyWidgetEnable && <GaslessDeposit />}
        </Masonry>
    )
}
